<template>
  <div>
    <div>
      <FillBlank :questionId="question.id" v-if="isFillBlank" :isQuestionPaper="submission && submission.isQuestionPaper"/>
      <MultipleChoice :question="question" v-if="isMultipleChoice" />
      <SingleChoice :question="question" v-if="isSingleChoice" />
      <TrueFalseChoice
        :question="question"
        v-if="isTrueFalseChoice"
        isCorrectHidden
        :isStudentAnswerCorrectShown="isStudentAnswerCorrectShown"
      />
      <LinkQuestion 
        :question="question" 
        v-if="isMatching" 
        :isQuestionPaper="submission && submission.isQuestionPaper"
      />
      <DragDrop 
        :question="question" 
        v-if="isDragDrop" 
        :isQuestionPaper="submission && submission.isQuestionPaper"
        :submission="submission" 
      />
      <Dropdown 
        :question="question" 
        v-if="isDropdown" 
        :isQuestionPaper="submission && submission.isQuestionPaper"
        :submission="submission" 
      />
    </div>
    <!-- <div v-if="submission && !submission.isQuestionPaper && question.correct && !isTrueFalseChoice && !isCorrectHidden" class="mt-1"> -->
    <div v-if="submission && !submission.isQuestionPaper && !submission.isStudentWork && question.correct && !isTrueFalseChoice && !isCorrectHidden" class="mt-1">
      <span class="font-weight-medium">Đáp án:&nbsp;</span>
      <span class="green--text" v-html="correct" />
    </div>
    <!-- <div v-if="hasExplain">
      <span class="font-weight-medium">Lời giải chi tiết:</span>
      <div v-html="explain" />
    </div> -->
  </div>
</template>
<script>
// constants
const FILL_BLANK_TYPES = ['fill-blank', 'fill-blank-child']
const MULT_CHOICE_TYPES = ['multiple-choice', 'multiple-choice-child']
const SIGL_CHOICE_TYPES = ['single-choice', 'single-choice-child']
const TRUE_FALSE_CHOICE_TYPES = ['true-false-choice', 'true-false-choice-child']
const LINK_TYPES = ['link-question-group', 'link-question-child']
const DRAG_DROP_TYPES = ['drag-drop-group', 'drag-drop-child']
const DROPDOWN_TYPES = ['dropdown-question-group', 'dropdown-question-child']
// components
import get from 'lodash-es/get'
import FillBlank from './FillBlank.vue'
import MultipleChoice from './MultipleChoice.vue'
import SingleChoice from './SingleChoice.vue'
import TrueFalseChoice from './TrueFalseChoice.vue'
import {handleCorrect} from '@/helpers/components/pdfRendererUtils'
import { mapGetters } from 'vuex'
import LinkQuestion from './LinkQuestion.vue' 
import DragDrop from './DragDrop.vue' 
import Dropdown from './Dropdown.vue'
export default {
  components: {FillBlank, MultipleChoice, SingleChoice, TrueFalseChoice, LinkQuestion, DragDrop, Dropdown},
  props: {
    question: Object,
    isCorrectHidden: Boolean,
    isStudentAnswerCorrectShown: {type: Boolean, default: true},
  },
  computed: {
    ...mapGetters({
      submission: 'pdfRender/getSubmission',
    }),
    isFillBlank() {
      return FILL_BLANK_TYPES.includes(this.question.type)
    },
    isMultipleChoice() {
      return MULT_CHOICE_TYPES.includes(this.question.type)
    },
    isSingleChoice() {
      return SIGL_CHOICE_TYPES.includes(this.question.type)
    },
    isTrueFalseChoice() {
      return TRUE_FALSE_CHOICE_TYPES.includes(this.question.type)
    },
    isMatching() {
      return LINK_TYPES.includes(this.question.type)
    },
    isDragDrop() {
      return DRAG_DROP_TYPES.includes(this.question.type)
    },
    isDropdown() {
      return DROPDOWN_TYPES.includes(this.question.type)
    }
    
  },
  data: () => ({correct: '', hasExplain: false, explain: ''}),
  watch: {
    question: {
      handler(val) {
        this.correct = handleCorrect(val)
        const isShowExplain = get(val, 'config.isShowExplain', false)
        this.hasExplain = isShowExplain
        if (isShowExplain) this.explain = get(val, 'config.explain', '')
      },
      immediate: true,
    },
  },
}
</script>
